if (!customElements.get('cutxi-review-personalization')) {
  customElements.define('cutxi-review-personalization', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.summaryLabels = JSON.parse(this.dataset.summaryLabels || '{}');
      this.variants = JSON.parse(this.dataset.variants);
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.refresh = () => this.update();
      document.addEventListener('change', e => {
        if (e.target.form === this.form) {
          this.update(); queueMicrotask(this.refresh);
        }
      }, options);
      this.addEventListener('input', this.refresh, options);
      this.form.addEventListener('submit', e => {
        this.update();
        if (!this.variant || !this.form.reportValidity()) {
          e.preventDefault(); e.stopImmediatePropagation();
        }
      }, {capture:true,signal:this.controller.signal});
      this.update();
    }
    disconnectedCallback() {this.controller?.abort();}
    update() {
      const priority = this.form.querySelector('input[name="properties[_urgency_level]"]:checked');
      const prioritySummary = this.querySelector('[data-priority-summary]');
      const hasPriority = Boolean(priority?.value);
      this.querySelector('[data-normal-production]').hidden = hasPriority;
      prioritySummary.hidden = !hasPriority;
      prioritySummary.textContent = hasPriority ? priority.closest('label').textContent.trim() : '';

      const inputs=Array.from(this.form.elements).filter(el=>el.matches('[data-variant-input]') && (el.type!=='radio'||el.checked));
      const selected=inputs.sort((a,b)=>a.dataset.index.localeCompare(b.dataset.index)).map(el=>el.value);
      this.variant=selected.length ? this.variants.find(v=>v.options.every((value,i)=>value===selected[i])) : this.variants.find(v=>String(v.id)===this.form.elements.namedItem('id')?.value);
      const cards=this.querySelector('[data-cards]');
      cards.hidden=cards.disabled=!(this.dataset.model==='poema' && this.variant?.option1==='Celebração');
      const name=this.querySelector('[data-name]');
      name.setCustomValidity(name.value&&!name.value.trim()?this.dataset.missing:'');
      this.querySelector('[data-configuration]').textContent=inputs.length ? inputs.map(el => el.tagName === 'SELECT' ? el.selectedOptions[0].textContent.trim() : el.labels[0].textContent.trim()).join(' / ') : this.variant?.title==='Default Title' ? this.dataset.productTitle : this.variant?.title || this.dataset.missing;
      const values=new Map();
      this.querySelectorAll('[name^="properties["]').forEach(el=>{
        if(el.matches(':disabled'))return;
        const label=el.name.slice(11,-1);
        if(el.type==='radio') {
          if(!values.has(label))values.set(label,this.dataset.missing);
          if(el.checked)values.set(label,el.closest('label')?.textContent.trim() || el.value);
        } else if(el.value.trim()||el.required)values.set(label,(el.tagName==='SELECT'?el.selectedOptions[0]?.textContent.trim():el.value.trim())||this.dataset.missing);
      });
      const summary=this.querySelector('[data-summary]');summary.replaceChildren();
      values.forEach((value,label)=>{
        const dt=document.createElement('dt'),dd=document.createElement('dd');
        dt.textContent=this.summaryLabels[label] || label;dd.textContent=value;summary.append(dt,dd);
      });
    }
  });
}

